import { createStyles, makeStyles, theme } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      padding: theme.spacing(1.5, 9.2),
    },
    buttonContainer: {
      paddingTop: theme.spacing(5),
      paddingBottom: `${theme.spacing(5)} !important`,
      textAlign: 'right',
    },
    textField: {
      '&.MuiSvgIcon-colorAction, .MuiSvgIcon-colorAction': {
        display: 'none',
      },
    },
    gridItem: {
      '&.MuiGrid-root': {
        paddingTop: theme.spacing(3),
      },
    },
  })
);
